// รูปแบบข้อมูลที่ Worker ส่งให้หน้าเกม

import type { SpeciesInfo } from "../engine/types";

export interface SpeciesCard {
  species: SpeciesInfo;
  className: string | null; // ชื่อวิทยาศาสตร์ระดับชั้น
  order: string | null;
  family: string | null;
  traitsEstimated: boolean; // true = ใช้ค่าประมาณจากกลุ่มย่อย
  countries: string[];
  rangeCells?: string | null; // ช่องกริดถิ่นที่อยู่จากบันทึกการพบ (BLOB ใน base64) ไม่มี = ใช้รายชื่อประเทศ
  areas?: CountryAreas; // จำกัดพื้นที่ในประเทศใหญ่ที่พบแค่บางส่วน (ใช้กับสัตว์ตัวอย่าง)
}

/** กรอบ [ใต้, ตะวันตก, เหนือ, ตะวันออก] เป็นองศา ต่อรหัสประเทศ */
export type CountryAreas = Readonly<Record<string, readonly (readonly [number, number, number, number])[]>>;

export interface SpawnResult extends SpeciesCard {
  seed: string;
  oneIn: number | null; // null เมื่อเปิดจากลิงก์แชร์
  source: "database" | "demo";
  poolSize: number | null; // จำนวนสัตว์ตัวอย่าง เมื่อ source = demo
}

export const SEED_PATTERN = /^[a-z0-9]{1,24}$/;
